import { dwCollect } from '@/utils/dw-collect';

/**
 * dw 点击【分类】
 *
 * @param appid
 * @param app_name
 */
export const dwOnTemplateTypeClick = (key1 = '') => {
  dwCollect({ module: 'template', element: 'class', action: 'click', key1 });
};

/**
 * dw Hover【更多】
 *
 * @param appid
 * @param app_name
 */
export const dwOnTemplateTypeMoreHover = () => {
  dwCollect({ module: 'template', element: 'more_class', action: 'hover' });
};

/**
 * dw 搜索
 *
 * @param appid
 * @param app_name
 */
export const dwOnTemplateTypeSearchClick = (key1 = '') => {
  dwCollect({ module: 'template', func: 'search', action: '回车', key1 });
};

/**
 * dw 点击热门搜索关键词
 *
 * @param appid
 * @param app_name
 */
export const dwOnTemplateTypeHotSearchClick = (key1 = '') => {
  dwCollect({ module: 'template', func: 'search', element: 'hot', action: 'click', key1 });
};

/**
 * dw 点击历史搜索关键词
 *
 * @param appid
 * @param app_name
 */
export const dwOnTemplateTypeHistorySearchClick = (key1 = '') => {
  dwCollect({ module: 'template', func: 'search', element: 'history', action: 'click', key1 });
};

/**
 * 点击【我要定制】
 */
export const dwOnDesignClick = () => {
  dwCollect({ element: 'make', action: 'click' });
};

/**
 * 【展开】显示
 */
export const dwOnShowMore = () => {
  dwCollect({ module: 'template', element: 'open', action: 'show' });
};

/**
 * 点击【展开】
 */
export const dwOnShowMoreClick = () => {
  dwCollect({ module: 'template', element: 'open', action: 'click' });
};
